<template>
    <div class="forms-feature__form-wrapper">
        <div class="migrol-rt-content">
            <h3 class="red">{{Strings['Forms.EnergyForum.ThankYouTitle']}}</h3>
            <div v-html="Strings['Forms.EnergyForum.ThankYouText']"></div>
        </div>        
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'Strings'
            ])
        }
    };
</script>